import { render, staticRenderFns } from "./EmailAdmin.vue?vue&type=template&id=31563574&scoped=true&"
import script from "./EmailAdmin.vue?vue&type=script&lang=ts&"
export * from "./EmailAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./EmailAdmin.vue?vue&type=style&index=0&id=31563574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31563574",
  null
  
)

export default component.exports